"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { CDN } from '@autoguru/global-configs';
import { Box, Column, Columns, Stack, Text, useResponsiveValue } from '@autoguru/overdrive';
import { Picture } from '@autoguru/picture';
import { forwardRef, useState } from 'react';
import * as styles from '~/src/components/ServiceProvidersFeedback/ServiceProvidersFeedback.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const maxFeedbackCharactersMobileView = 140;

// @ts-ignore
export const ServiceProvidersFeedbackCarousel = /*#__PURE__*/forwardRef(({
  isDesktop,
  item
}, ref) => {
  const [isEntireFeedbackShown, setIsEntireFeedbackShown] = useState(false);
  const onShowMore = e => {
    setIsEntireFeedbackShown(true);
    e.preventDefault();
    e.stopPropagation();
  };
  return /*#__PURE__*/_jsx(Box, {
    ref: ref,
    children: /*#__PURE__*/_jsxs(Stack, {
      space: "4",
      children: [/*#__PURE__*/_jsxs(Box, {
        padding: "4",
        display: "flex",
        flexDirection: ['column',, 'row'],
        className: isDesktop ? styles.feedbackDesktop : styles.feedbackMobile,
        children: [/*#__PURE__*/_jsx(Box, {
          paddingRight: "1",
          children: /*#__PURE__*/_jsx(Picture, {
            lazy: true,
            backgroundColor: "transparent",
            altText: "quotation",
            width: 24,
            height: 12,
            aspectRatio: 24 / 12,
            src: `${CDN}/images/booking-guru/landing/quotation-mark.svg`
          })
        }), isDesktop ? /*#__PURE__*/_jsx(Box, {
          paddingTop: "2",
          children: /*#__PURE__*/_jsx(Text, {
            as: "p",
            size: "4",
            colour: "white",
            children: item.feedback
          })
        }) : /*#__PURE__*/_jsxs(Box, {
          paddingTop: "2",
          children: [/*#__PURE__*/_jsx(Box, {
            paddingBottom: !isEntireFeedbackShown ? '3' : 'none',
            children: /*#__PURE__*/_jsx(Text, {
              as: "p",
              size: "4",
              colour: "white",
              children: !isEntireFeedbackShown ? `${item.feedback.substring(0, maxFeedbackCharactersMobileView)}...` : item.feedback
            })
          }), !isEntireFeedbackShown && /*#__PURE__*/_jsx(Box, {
            as: "button",
            onClick: onShowMore,
            children: /*#__PURE__*/_jsx(Text, {
              strong: true,
              colour: "white",
              className: styles.btnShowMore,
              children: "Show more"
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(Columns, {
        noWrap: useResponsiveValue([false,, true]),
        alignItems: "center",
        space: "3",
        paddingTop: "4",
        paddingLeft: ['none', '7'],
        children: [/*#__PURE__*/_jsx(Column, {
          width: ['full', 'auto'],
          justifyContent: ['center',, 'start'],
          paddingRight: ['none', '4'],
          children: /*#__PURE__*/_jsx(Picture, {
            lazy: true,
            backgroundColor: "transparent",
            src: item.profileImg,
            width: 48,
            height: 48,
            imageSizes: "100vw",
            aspectRatio: 1,
            altText: item.altProfileImg
          })
        }), /*#__PURE__*/_jsx(Column, {
          width: ['full', 'auto'],
          justifyContent: ['center',, 'start'],
          children: /*#__PURE__*/_jsxs(Stack, {
            space: "none",
            alignItems: isDesktop ? 'start' : 'center',
            children: [/*#__PURE__*/_jsx(Text, {
              strong: true,
              as: "p",
              size: "4",
              colour: "white",
              children: item.heading
            }), /*#__PURE__*/_jsx(Text, {
              as: "p",
              size: "4",
              colour: "white",
              children: item.company
            })]
          })
        })]
      })]
    })
  });
});